import React from 'react';
import { Icon } from 'ui';

const SelectedCriterion = ({ selectedCriterion, deleteCriterion }) => {
  return (
    <div className="Criterion d-f jc-sb ai-c">
      <div>
        {selectedCriterion.name}
        <span className="Criterion-description">
          <span className="Criterion-hyphen"> &ndash; </span>
          {selectedCriterion.description}
          {!selectedCriterion.description && (
            <em>{t('feedback_criteria.criterion.no_description')}.</em>
          )}
        </span>
      </div>
      <Icon
        name="error"
        className="FeedbackCriteria-controls fz-bigger"
        onClick={() => deleteCriterion(selectedCriterion.id)}
      />
    </div>
  );
};

export default SelectedCriterion;
